import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useLazyGetUsersQuery } from '../../../store/user/user'
import { type User } from '../../../models/User'
import { type CustomTemplateValue, type TemplateLookup } from '../../../models/TemplateLibrary'

export const useTemplateCreators = (templates: TemplateLookup[] | undefined) => {
  const accountId = useAppSelector(selectAccountId)
  const [usersById, setUsersById] = useState<{ [key: string]: User }>({})
  const [triggerGetUsers] = useLazyGetUsersQuery()

  useEffect(() => {
    const updateUserNamesById = async () => {
      if (!templates) {
        return
      }

      try {
        const response = await triggerGetUsers({
          accountId,
          ids: [templates.filter((template) => 'createdBy' in template).map((template) => (template as CustomTemplateValue).createdBy)].flat(),
          identityTypes: ['idp'],
          pageRequest: { size: 500, page: 0 },
        }).unwrap()
        if (!response?.data) {
          return
        }
        setUsersById(
          response.data.reduce((acc: { [key: string]: User }, user: User) => {
            acc[user.id] = user
            return acc
          }, {}),
        )
      } catch (e) {
        console.error(e)
      }
    }
    updateUserNamesById()
  }, [templates, accountId, triggerGetUsers])

  return usersById
}
